import { render, staticRenderFns } from "./PictureComponent.vue?vue&type=template&id=a890cb42&"
import script from "./PictureComponent.vue?vue&type=script&lang=js&"
export * from "./PictureComponent.vue?vue&type=script&lang=js&"
import style0 from "./PictureComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports